module.exports = __webpack_public_path__ + "img/sh-klogos.95bcf679.png";